import {
  PopoverPanel as BasePopoverPanel,
  PopoverPanelProps,
} from "@headlessui/react";
import { DEFAULT_POPOVER_GAP, DEFAULT_POPOVER_PLACEMENT } from "./constants";
import { twMerge } from "tailwind-merge";

export function PopoverPanel({
  anchor,
  children,
  className,
}: Pick<PopoverPanelProps, "anchor" | "children"> & { className?: string }) {
  return (
    <BasePopoverPanel
      anchor={
        anchor ?? { to: DEFAULT_POPOVER_PLACEMENT, gap: DEFAULT_POPOVER_GAP }
      }
      className={twMerge(
        "w-content p-4 bg-neutral-300 border border-neutral-800 rounded-xl shadow-flat-left",
        className,
      )}
    >
      {children}
    </BasePopoverPanel>
  );
}
